import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, SecurityContext } from '@angular/core';

import { Attachment } from '../../../models/attachment';

import { FileManagerService } from '../../file-manager/file-manager.service';
import { WatermarkService } from '../../watermark/watermark.service';
import { ModuleKeyDefinition } from '../../../constants/module.constant';
import { ModuleManagerService } from '../../../webclient/services/module/module-manager.service';
import { FileFactoryService } from '../../file-factory/file-factory.service';
import { TnNotificationService } from '../../tn-notification/tn-notification.service';
import { TeamnoteConfigService } from '../../../configs/teamnote-config.service';
import { AnnotationLayerRenderedEvent } from 'ngx-extended-pdf-viewer';
import { DomSanitizer } from '@angular/platform-browser';
import { WebclientService } from '../../../webclient/webclient.service';

@Component({
  selector: 'tn-attachment-pdf',
  templateUrl: './attachment-pdf.component.html',
  styleUrls: ['./attachment-pdf.component.scss']
})
export class AttachmentPdfComponent implements OnInit {
  @Input() attachment: Attachment;
  @Input() attachmentId: string;
  @Input() filename: string;
  @Input() isDisableWatermark: boolean = false;
  @Input() isDisableDownload: boolean = false;
  @Input() isChatMessage: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  @ViewChild ('pdfCanvas', {static: false}) pdfCanvas: ElementRef;
  @ViewChild('imageWatermarkCanvas', {static: false}) imageWatermarkCanvas: ElementRef;

  isPDF: boolean = false;
  isAllowAttachmentSave: boolean = false;
  fileUrl: string;
  page: number = 1;
  isPdfLoading: boolean = false;

  constructor(
    private _fileManagerService: FileManagerService,
    private _watermarkService: WatermarkService,
    private _moduleManagerService: ModuleManagerService,
    private _fileFactoryService: FileFactoryService,
    private _tnNotificationService: TnNotificationService,
    private _teamnoteConfigService: TeamnoteConfigService,
    private _sanitizer: DomSanitizer,
    private _webclientService: WebclientService,
  ) {}

  ngOnInit() {
  }
  ngOnChanges() {
    if (!this.attachmentId) {
      this.fileUrl = '';
      return;
    }
    if (this.attachmentId.includes('blob:http')) {
      this.isPDF = this._fileManagerService.checkIfAttachmentIsPdf(this.filename);
    }else {
      this.isPDF = this._fileManagerService.checkIfAttachmentIsPdf(this.attachmentId);
    }

    if (this.isChatMessage) {
      this.isAllowAttachmentSave = this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE) || this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE_WEB);

      //Always allow attachment download
      if (this._teamnoteConfigService.config.WEBCLIENT.CHATROOM.IS_ALWAYS_ALLOW_DOWNLOAD){
        this.isAllowAttachmentSave = true;
      }

      if (this._webclientService.allow_download_secure_message_webclient){
        this.isDisableDownload = false;
      }
    }

    // this.page = 1;
    this.isPdfLoading = true;
    this._fileFactoryService.getFileByAttachmentId(
      this.attachmentId,
      (blobUrl) => {
        this.fileUrl = this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, this._sanitizer.bypassSecurityTrustResourceUrl(blobUrl))
      },
      (err) => {},
      true
    )
  }

  ngAfterViewInit() {
    // this.onPdfInit();
    this.drawOverlayWatermark();
  }

  drawOverlayWatermark(): void {
    if (this.isDisableWatermark) {
      return;
    }
    if (!this.imageWatermarkCanvas) {
      return;
    }
    let watermarkCanvas: HTMLCanvasElement = this.imageWatermarkCanvas.nativeElement;
    let parent = watermarkCanvas.parentElement;
    let imgW = parent.clientWidth;
    let imgH = parent.clientHeight;
    watermarkCanvas.width = imgW;
    watermarkCanvas.height = imgH;
    let watermarkContext = watermarkCanvas.getContext("2d");
    this._watermarkService.drawWatermark(watermarkContext, imgW, imgH);
  }

  onAnnotationLayerRendered(event: AnnotationLayerRenderedEvent): void {
    const viewer = event.source.div as HTMLDivElement;

    if (viewer) {
      const externalLinks = viewer.getElementsByTagName('a');

      for (let i = 0; i < externalLinks.length; i++) {
        externalLinks[i].setAttribute('target', '_blank');
        externalLinks[i].setAttribute('rel', 'noopener noreferrer');
      }
    }
  }

  downloadFile(): void {
    if (this.attachmentId.includes('blob:http')) {
      const link = document.createElement('a');
      link.download = this.filename;
      link.href = this.attachmentId;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }else {
      this._fileManagerService.downloadFileByAttachmentId(
        this.attachmentId, this.attachment ? this.attachment.filename : this.attachmentId);
    }
  }

  onPdfLoading(): void {
    this.isPdfLoading = true;
  }

  onPageRendered(): void {
    this.isPdfLoading = false;
  }

  onPdfLoadingFailed(): void {
    this.isPdfLoading = false;
  }

}

